import { Component, OnInit } from '@angular/core';
import * as sphereKnn from 'sphere-knn';
import * as geodist from 'geodist';

import { PointOfInterestCollector } from './poi-collector';
import { PointOfInterest, POIType } from '../core/poi';
import { StopCollector } from './stop-collector';
import { PanelDataExchangeService } from './panel-data-exchange.service';

@Component({
    selector: 'info-filter-panel',
    templateUrl: './info-filter-panel.component.html',
    styleUrls: ['./panel.scss', './info-filter-panel.component.scss']
})
export class InfoFilterPanelComponent implements OnInit {
    point: PointOfInterest;
    stops: any[];

    constructor(
        private collector: PointOfInterestCollector,
        private exchanger: PanelDataExchangeService,
        private stopCollector: StopCollector) { this.stops = []; }

    ngOnInit() {
        this.collector.afterDisable.on((data: any) => {
            if (!this.point)
                return;

            if (data.type === POIType.Mall) {
                switch (this.point.type) {
                    case POIType.Mall:
                    case POIType.Supermarket:
                        this.reset();
                        break;
                }
            } else if (data.type === POIType.Hospital) {
                switch (this.point.type) {
                    case POIType.Kindergarten:
                    case POIType.School:
                    case POIType.University:
                    case POIType.Hospital:
                    case POIType.Clinic:
                    case POIType.Doctor:
                    case POIType.Police:
                        this.reset();
                        break;
                }
            } else if (data.type === POIType.SubwayStation) {
                switch (this.point.type) {
                    case POIType.SubwayStation:
                    case POIType.RailwayStation:
                        this.reset();
                        break;
                }
            } else if (data.type === POIType.Cafe) {
                switch (this.point.type) {
                    case POIType.Cafe:
                    case POIType.Cinema:
                    case POIType.Theatre:
                    case POIType.Pub:
                    case POIType.Nightclub:
                    case POIType.Restaurant:
                    case POIType.Bar:
                        this.reset();
                        break;
                }
            }
        });

        this.collector.afterSelect.on((point: PointOfInterest) => {
            this.point = point;

            //TODO need to initialize stopCollector firstly
            let stopsLookup = sphereKnn(this.stopCollector.stops.map((s) => {
                return {
                    id: s.id,
                    name: s.name,
                    latitude: s.coordinate.latitude,
                    longitude: s.coordinate.longitude
                };
            }));

            let closestStops = stopsLookup(point.position.latitude, point.position.longitude, 5);
            let stops = closestStops.map(s => {
                let start = [s.latitude, s.longitude];
                let end = [point.position.latitude, point.position.longitude];
                let distance = geodist(start, end, { unit: 'meters' });
                distance = distance / 1000 > 1
                    ? geodist(start, end, { unit: 'km' }) + ' км'
                    : distance + ' м';
                return {
                    id: s.id,
                    name: s.name,
                    distance: distance
                };
            });

            this.stops = [];
            stops.forEach(stop => {
                if (this.stops.length >= 3)
                    return;
                if (!this.stops.some(s => stop.name === s.name))
                    this.stops.push(stop);
            });
        });
    }

    close() {
        this.reset();
        this.collector.unselect();
        this.exchanger.showPOIInfoPanel(false);
    }

    hover(id: number, isSelected: boolean) {
        if (isSelected)
            this.stopCollector.highlight(id);
        else
            this.stopCollector.unhighlight(id);
    }

    select(id: number) {
        this.stopCollector.select(id);
    }

    private reset() {
        this.point = null;
        this.stops = [];
    }
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/info-filter-panel.component.ts